export enum UIStateEvent {
    SETTINGS_OPEN_CHANGED = 'uiSettingsOpenChanged',
    ACTIVE_PANEL_CHANGED = 'uiPanelChanged',
    ACTIVE_POPUP_CHANGED = 'uiPopupChanged',
}
